import { render, staticRenderFns } from "./FirebaseImg.vue?vue&type=template&id=57f010f6&"
import script from "./FirebaseImg.vue?vue&type=script&lang=js&"
export * from "./FirebaseImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports